import { FeatureProfile } from '@mdlbeasts/nofomo.ui.web';
import { Box } from '@mui/material';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Routes } from 'constants/routes.constants';
import { useFavourites } from 'restful/accounts';

const FavoritesStack = () => {
  const intl = useIntl();
  const router = useRouter();

  const { favourites: favouriteEvents } = useFavourites({
    type: 'event',
    limit: 2,
  });
  const { favourites: favouriteArtists } = useFavourites({
    type: 'artist',
    limit: 2,
  });

  const items = useMemo(() => {
    const next: FeatureProfile.Favorites.FavoriteStackProps['items'] = [];

    if (favouriteEvents.length > 0) {
      next.push({
        type: 'bookmark',
        text: intl.formatMessage({ id: 'profile.favorites.events.title' }),
        images: favouriteEvents.flatMap((favourite) =>
          favourite.image ? [favourite.image] : [],
        ),
      });
    }

    if (favouriteArtists.length > 0) {
      next.push({
        type: 'favorite',
        text: intl.formatMessage({ id: 'profile.favorites.artists.title' }),
        images: favouriteArtists.flatMap((favourite) =>
          favourite.image ? [favourite.image] : [],
        ),
      });
    }

    return next;
  }, [favouriteArtists, favouriteEvents, intl]);

  if (items.length === 0) {
    return null;
  }

  const handlePress = (type: FeatureProfile.Favorites.FavoriteType) =>
    router.push(
      type === 'bookmark'
        ? Routes.AccountFavoritesEvents
        : Routes.AccountFavoritesArtists,
    );

  return (
    <Box sx={{ mt: 5 }}>
      <FeatureProfile.Favorites.Stack
        items={items}
        actions={{ press: handlePress }}
      />
    </Box>
  );
};

export default FavoritesStack;
